import { useEffect } from "react";
import { client, useClient } from "../lib/client.ts";
import { alertService } from "../ui/ring.ts";

/** Rejected edits and other failures from the client store, shown as Ring alerts (bottom-left stack, like YouTrack). */
export function RingAlerts() {
  const errors = useClient((s) => s.errors);
  useEffect(() => {
    for (const e of errors) {
      alertService.error(
        <>
          <b>{label(e.code)}</b> — {e.message}
        </>,
      );
      client.dismissError(e.id);
    }
  }, [errors]);
  return null;
}

function label(code: string): string {
  switch (code) {
    case "conflict":
      return "Edit rolled back: someone changed this issue first";
    case "forbidden":
      return "Not allowed";
    case "validation":
      return "Rejected";
    case "network":
      return "Network";
    default:
      return code;
  }
}
